import {
  setEditRole,
  setPermissionByCategory,
  setRolesPermissionViewOnly,
  setSelectedPermissions,
  setSelectedRole,
  togglePermissionModal,
  toggleRoleModal,
} from "pages/ManageRoles/roleSlice";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComp from "themes/elements/Modal";
import TagComp from "themes/elements/Tag";
import { retrieveUserData } from "utils/cryptoStorage";
import { isPermit } from "utils/permissionCheck";
import ModalFooter from "../modalFooter";
import style from "./role_details.module.scss";

function RoleDetails({ open, setOpen, setEdit }) {
  const userToken = retrieveUserData();
  const dispatch = useDispatch();
  let admin_user_id, admin_user_name;
  const [loading, setLoading] = useState(false);

  if (userToken) {
    ({ admin_user_id, admin_user_name } = userToken);
  }
  const { selectedRole } = useSelector((state) => state.roles);

  const handleEdit = (data) => {
    dispatch(setSelectedRole(data));

    // Group permissions based on module_id
    const groupedPermissions = {
      roleManagement: [],
      userManagement: [],
      notificationManagement: [],
      newsManagement: [],
      wardManagement: [],
      incidentManagement: [],
      counsilorManagement: [],
      projectManagement: [],
    };

    data?.permissions.forEach((permission) => {
      switch (permission?.module_id) {
        case 1:
          groupedPermissions.roleManagement.push(permission.permission_name);
          break;
        case 2:
          groupedPermissions.userManagement.push(permission.permission_name);
          break;
        case 3:
          groupedPermissions.newsManagement.push(permission.permission_name);
          break;
        case 4:
          groupedPermissions.notificationManagement.push(
            permission.permission_name
          );
          break;
        case 5:
          groupedPermissions.wardManagement.push(permission.permission_name);
          break;
        case 6:
          groupedPermissions.incidentManagement.push(
            permission.permission_name
          );
          break;
        case 7:
          groupedPermissions.counsilorManagement.push(
            permission.permission_name
          );
          break;
        case 8:
          groupedPermissions.projectManagement.push(permission.permission_name);
          break;
        default:
          break;
      }
    });

    // Dispatch updates for each category
    dispatch(
      setPermissionByCategory({
        category: "roleManagement",
        permissions: groupedPermissions.roleManagement,
      })
    );
    dispatch(
      setPermissionByCategory({
        category: "userManagement",
        permissions: groupedPermissions.userManagement,
      })
    );
    dispatch(
      setPermissionByCategory({
        category: "notificationManagement",
        permissions: groupedPermissions.notificationManagement,
      })
    );
    dispatch(
      setPermissionByCategory({
        category: "newsManagement",
        permissions: groupedPermissions.newsManagement,
      })
    );

    dispatch(
      setPermissionByCategory({
        category: "wardManagement",
        permissions: groupedPermissions.wardManagement,
      })
    );
    dispatch(
      setPermissionByCategory({
        category: "incidentManagement",
        permissions: groupedPermissions.incidentManagement,
      })
    );
    dispatch(
      setPermissionByCategory({
        category: "counsilorManagement",
        permissions: groupedPermissions.counsilorManagement,
      })
    );
    dispatch(
      setPermissionByCategory({
        category: "projectManagement",
        permissions: groupedPermissions.projectManagement,
      })
    );

    const permissionsForDispatch = data.permissions.map(
      (permission) => permission.permission_name
    );
    dispatch(setSelectedPermissions(permissionsForDispatch));
  };

  return (
    <ModalComp
      title="Role details"
      footer={
        <ModalFooter
          handleSecondaryBtn={() => {
            handleEdit(selectedRole);
            dispatch(setRolesPermissionViewOnly(true));
            dispatch(setEditRole(false));
            dispatch(togglePermissionModal(true));
            setOpen(false);
          }}
          handlePrimaryBtn={() => {
            handleEdit(selectedRole);
            setOpen(false);
            dispatch(setEditRole(true));
            dispatch(toggleRoleModal(true));
          }}
          primaryBtnloading={loading}
          secondaryBtnText="View permissions"
          primaryBtnVariant="secondary"
          primaryBtnText="Edit role"
          hidePrimaryBtn={!isPermit(1, "edit")}
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className={`flex  gap-6 ${style["content-wrapper"]}`}>
        <div className="flex flex-column gap-4 w-full">
          {/* Name */}
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Name
            </label>
            <h6 className={style["details-value"]}>
              {selectedRole?.role_name}
            </h6>
          </div>
          {/* Email */}
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Description
            </label>
            <h6 className={style["details-value"]}>
              {selectedRole?.role_description}
            </h6>
          </div>
          {/* Created date */}
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Number of users
            </label>
            <h6 className={style["details-value"]}>
              {selectedRole?.no_of_users}
            </h6>
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Created on
            </label>
            <h6 className={style["details-value"]}>
              {selectedRole?.created_date}
            </h6>
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Status
            </label>
            <TagComp
              className={
                selectedRole?.role_status_flg === 1
                  ? "ant-tag-green"
                  : "ant-tag-red"
              }
            >
              {selectedRole?.role_status_flg === 1 ? "Active" : "Inactive"}
            </TagComp>
          </div>
        </div>
      </div>
    </ModalComp>
  );
}

export default RoleDetails;
